<template>
  <b-modal
    ref="modal"
    title="Convert"
    centered
    @hide="closeHandler"
    @show="reset"
  >
    <template
      v-if="options.length"
      #modal-footer
    >
      <ButtonPrimary
        variant="primary"
        :disabled="!option || isLoading"
        @click="accept"
      >
        Yes
      </ButtonPrimary>
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        No
      </ButtonOutline>
    </template>

    <template
      v-else
      #modal-footer
    >
      <ButtonOutline
        variant="outline-primary"
        @click="$refs.modal.hide()"
      >
        Cancel
      </ButtonOutline>
    </template>

    <div v-if="!isLoading">
      <b-form-group v-if="options.length">
        <b-form-radio
          v-for="opt in options"
          :key="opt"
          v-model="option"
          :value="opt"
        >
          {{ opt }}
        </b-form-radio>
      </b-form-group>
      <b-form-group
        v-if="options.length"
        label="Conversion Options"
      >
        <b-form-select
          v-model="conversionOption"
          :options="conversionOptions"
        />
      </b-form-group>

      <b-alert
        v-else
        variant="danger"
        show
      >
        Cannot convert the selections which are not similar file type
      </b-alert>
    </div>

    <b-spinner v-else />
  </b-modal>
</template>

<script>
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import mixinModal from './mixin'
import { createNamespacedHelpers } from 'vuex'
import {IMAGE_FILE_TYPES, VIDEO_FILE_TYPES} from "../constants";
import Requests from "../../../../services/api/file-browser";
import {FILE_TYPE} from "../../../../constants/file-image-types";

const { mapGetters, mapActions } = createNamespacedHelpers('fileBrowser')

const TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  PDF: FILE_TYPE.PDF,
  AI: FILE_TYPE.AI,
  TIF: FILE_TYPE.TIF,
  TIFF: FILE_TYPE.TIFF,
}

const TYPE_MAP = {
  [TYPES.IMAGE]: ['JPG', 'PNG', 'WEBP'],
  [TYPES.VIDEO]: ['MP4', 'WEBM'],
  [TYPES.PDF]: ['SVG'],
  [TYPES.AI]: ['PNG'],
  [TYPES.TIF]: ['PNG'],
}

export default {
  name: "ConvertModal",
  components: {ButtonOutline, ButtonPrimary},
  mixins: [
    mixinModal
  ],
  data: () => ({
    option: null,
    isLoading: false,
    conversionOption: 'copy',
    conversionOptions: [
      { value: 'copy', text: 'Copy existing image before conversion' },
      { value: 'replace', text: 'Replace existing image' }
    ],
  }),
  computed: {
    ...mapGetters(['selectedItems']),
    options() {
      switch (true) {
        case this.selectedItems?.every(item => Object.keys(item).includes('product_name') && (item.type === TYPES.TIF || item.type === TYPES.TIFF)):
          return TYPE_MAP[TYPES.TIF];
        case this.selectedItems?.every(item => ['mov', 'mp4'].includes(item.type)):
          return [...TYPE_MAP[TYPES.VIDEO],'GIF']
        case this.selectedItems?.every(item => VIDEO_FILE_TYPES.includes(item.type)):
          return TYPE_MAP[TYPES.VIDEO];
        case this.selectedItems?.every(item => IMAGE_FILE_TYPES.includes(item.type)):
          return TYPE_MAP[TYPES.IMAGE];
        case this.selectedItems?.every(item => item.type === TYPES.PDF):
          return TYPE_MAP[TYPES.PDF];
        case this.selectedItems?.every(item => item.type === TYPES.AI):
          return TYPE_MAP[TYPES.AI];
        default:
          return [];
      }
    }
  },
  methods: {
    ...mapActions(['fetchList']),
    reset() {
      // if there is only one option - select it by default
      if (this.options.length === 1) {
        this.option = this.options[0]; 
      } else {
        this.option = null;
      }
      this.isLoading = false;
      this.conversionOption = 'copy';
    },
    async accept() {
      this.isLoading = true;
      const isProducts = this.selectedItems.some(item => Object.keys(item).includes('product_name'));
      if (isProducts) {
       try {
          await Requests.convertProductImage(this.selectedItems.map(({ id }) => id), this.option.toLowerCase(), this.conversionOption)
          this.fetchList();
        } catch (error) {
          toastr.error('Something went wrong while converting.')
        } finally {
          this.close();
        }
       
       } else {
        if (this.selectedItems.length === 1) {
          try {
            await Requests.convertFolderFile(this.selectedItems.map(({ id }) => id), this.option.toLowerCase(), this.conversionOption)
            this.fetchList();
          } catch (error) {
            toastr.error('Something went wrong while converting.')
          } finally {
            this.close();
          }
        } else {
          try {
            let [firstItem] = this.selectedItems;
            let firstParentId = firstItem ? firstItem.parent_id : null;
            await Requests.convertFolderFileUsingBackgroundJob(this.selectedItems.map(({ id }) => id), this.option.toLowerCase(), firstParentId, this.conversionOption);
            toastr.success(
              "You will get an email when files are done converting!"
            );
          } catch (error) {
            toastr.error('Something went wrong while converting.')
          } finally {
            this.close();
          }
        }
      }

    }
  }

}
</script>

<style scoped lang="scss">

</style>
